import { createContext } from "react";

export const StateContext = createContext();
function AppContext({ children }) {
  return <StateContext.Provider value={{}}>{children}</StateContext.Provider>;
}

export default AppContext;
